import { useEffect } from "react";
import "@innovatrics/dot-auto-capture-ui/document";

function DocumentUI(props) {
	useEffect(() => {
		const uiElement = document.getElementById("x-dot-document-auto-capture-ui");

		if (uiElement) {
			uiElement.props = {
				...props
			};
		}

		const svg = document.querySelector("#x-dot-document-auto-capture-ui svg");
		if (svg) {
			svg.querySelectorAll("rect").forEach((rect) => {
				rect.setAttribute("rx", "50"); // rounded corners
				rect.setAttribute("ry", "50");
			});
		}
	});

	return <x-dot-document-auto-capture-ui id="x-dot-document-auto-capture-ui" />;
}

export default DocumentUI;
